<script lang="ts">
    import { cx } from '$lib/utils/cx';
    import type { Action } from 'svelte/action';
    import { createResizeObserver } from '$lib/utils/resizeObserver';
    import { fade } from 'svelte/transition';

    export let defaultClass = 'overflow-y-auto';
    let className = '';
    export { className as class };

    let clientHeight = 0;
    let scrollTop = 0;
    let scrollHeight = 0;

    export const action: Action<HTMLDivElement> = (node) => {
        const { useResizeObserver, entries } = createResizeObserver();
        const { destroy } = useResizeObserver(node);

        function sync() {
            clientHeight = node.clientHeight;
            scrollTop = node.scrollTop;
            scrollHeight = node.scrollHeight;
        }

        const unsub = entries.subscribe((_) => {
            sync();
        });

        function scrollListener() {
            sync();
        }

        node.addEventListener('scroll', scrollListener);

        return {
            destroy() {
                destroy();
                unsub();
                node.removeEventListener('scroll', scrollListener);
            },
        };
    };

    $: displayTop = scrollTop > 0;
    $: displayBottom =
        Math.floor(scrollHeight - scrollTop) > clientHeight &&
        scrollHeight > clientHeight;
</script>

<div class={cx(defaultClass, className)} use:action>
    {#if displayTop}
        <div
            transition:fade={{ duration: 250 }}
            class={cx('left-0 right-0 top-0 sticky pointer-events-none')}
        >
            <div
                class="bg-gradient-to-b from-black/5 to-black/0 h-[40px] absolute top-0 left-0 right-0 pointer-events-none"
            ></div>
        </div>
    {/if}

    <slot />

    {#if displayBottom}
        <div
            transition:fade={{ duration: 250 }}
            class={cx('left-0 right-0 bottom-0 sticky pointer-events-none')}
        >
            <div
                class="bg-gradient-to-t from-black/5 to-black/0 h-[40px] absolute bottom-0 left-0 right-0 pointer-events-none"
            ></div>
        </div>
    {/if}
</div>
